/**
 * useBackofficeApplications
 * Fetches and manages list of applications from /backoffice/applications
 */
import { useQuery } from '@tanstack/react-query';
import { listApplications } from '@/services/credit-engine.service';
import { PARTNER_ID } from '@/constants';

export function useBackofficeApplications() {
  const query = useQuery({
    queryKey: ['backoffice', 'applications', PARTNER_ID],
    queryFn: () => listApplications(PARTNER_ID),
  });

  return {
    applications: query.data?.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
